"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.acceptPromotionInvite = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("../payloads/constants");
function acceptPromotionInvite(options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { signalData, invitorAddress, spaceId } = options || {};
        // accept the promotion invite
        this.acceptRequest({
            signalData,
            senderAddress: this.data.local.address,
            recipientAddress: invitorAddress,
            chatId: spaceId,
            details: {
                type: constants_1.SPACE_ACCEPT_REQUEST_TYPE.ACCEPT_INVITE,
                data: {},
            },
        });
    });
}
exports.acceptPromotionInvite = acceptPromotionInvite;
//# sourceMappingURL=acceptPromotionInvite.js.map